import { FeatureAffiliate } from '@mdlbeasts/nofomo.ui.web';

import {
  useAffiliateNoticeState,
  useAffiliatePartner,
  useAffiliateStoreActions,
} from 'services/stores/affiliate/hooks';

type AffiliateNoticeProps = {
  eventName: string;
};

/**
 * Event Notice when redirected from an affiliate partner
 * @constructor
 */
export const AffiliateNotice = (props: AffiliateNoticeProps) => {
  const storeAction = useAffiliateStoreActions();
  const partner = useAffiliatePartner();
  const noticeVisible = useAffiliateNoticeState();

  return (
    <FeatureAffiliate.NoticeRedirected
      visible={noticeVisible && !!partner}
      event={{
        name: props.eventName,
      }}
      partner={{ name: partner?.name || '' }}
      actions={{
        close: () => storeAction.closeNotice(),
      }}
    />
  );
};
